import Vue from 'vue';
import ServiceUtils from "@/common/utils/ServiceUtils.js";

const URL_UNIVERSAL_LINK = "url-universal-link";
const URL_APP_STORE = "url-app-store";
const GOOGLE_AUTHENTICATE = "google-authenticate";
const URL_WEB_APP_STORE_LINK = "url-webappstore-link";
const URL_DEEP_LINK = "url-deep-link";
const URL_ANDROID_LINK = "url-android-link";

Vue.directive("open-app-mobile", {
    // eslint-disable-next-line no-unused-vars
    bind: function (el, binding, vnode) {
        const {isIOS, isAndroid, IOSVersion} = Vue.prototype;
        const {attributes} = el;
        const urlUniversalLink = getValueOfAttributes(URL_UNIVERSAL_LINK, attributes);
        const urlAppStore = getValueOfAttributes(URL_APP_STORE, attributes);
        const googleAuthenticate = getValueOfAttributes(GOOGLE_AUTHENTICATE, attributes);
        const urlWebAppStoreLink = getValueOfAttributes(URL_WEB_APP_STORE_LINK, attributes);
        const urlDeepLink = getValueOfAttributes(URL_DEEP_LINK, attributes);
        const urlAndroidLink = getValueOfAttributes(URL_ANDROID_LINK, attributes);
        el.addEventListener("click", function () {
            ServiceUtils.openMobileApp(urlUniversalLink, urlAppStore, googleAuthenticate, urlWebAppStoreLink, urlDeepLink, urlAndroidLink, isIOS, isAndroid, IOSVersion);
        });
    },
});

const getValueOfAttributes = (key, obj) => {
    if (!obj[key]) {
        return null;
    }
    return obj[key].value;
};
